import styles from "./SkeletonField.module.css";

export const SkeletonField = () => {
  return <div className={styles.skeletonLoader}></div>;
};
